import interceptor from 'js/vue-plugins/vue-resource/interceptors/basic'
 
export default [interceptor]
